import { EMAIL_PREVIEW_BASE_STYLES } from "../constants/emailPreviewStyles";

/** Strip document-level wrappers so pasted embed HTML renders correctly in preview. */
export const normalizeForPreviewRender = (html?: string): string => {
  if (!html) return "";
  try {
    if (typeof document === "undefined") return html;
    const wrapper = document.createElement("div");
    wrapper.innerHTML = html;

    const htmlNode = wrapper.querySelector("html") as HTMLElement | null;
    const root = (htmlNode || wrapper) as HTMLElement;
    const bodyNode = root.querySelector("body") as HTMLElement | null;
    const contentRoot = (bodyNode || root) as HTMLElement;

    contentRoot
      .querySelectorAll("head, meta[charset]")
      .forEach((el) => el.remove());

    return contentRoot.innerHTML;
  } catch {
    return html;
  }
};

export const createBlobUrlFromHtml = (html: string): string => {
  const raw = html && html.trim() ? html : "<p>No email body entered</p>";
  const previewHtml = normalizeForPreviewRender(raw);
  const fullHtml = `<!DOCTYPE html>
<html>
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <style>${EMAIL_PREVIEW_BASE_STYLES}</style>
</head>
<body>
  <div class="ql-snow">
    <div class="ql-editor">${previewHtml}</div>
  </div>
  <script>
    function sendHeight() {
      const height = Math.max(
        document.body.scrollHeight,
        document.body.offsetHeight,
        document.documentElement.clientHeight,
        document.documentElement.scrollHeight,
        document.documentElement.offsetHeight
      );
      if (window.parent) {
        window.parent.postMessage({ type: 'SB_EMAIL_PREVIEW_HEIGHT', height: height }, '*');
      }
    }
    window.addEventListener('load', sendHeight);
    window.addEventListener('resize', sendHeight);
    setTimeout(sendHeight, 100);
    setTimeout(sendHeight, 500);
  </script>
</body>
</html>`;
  const blob = new Blob([fullHtml], { type: "text/html" });
  return URL.createObjectURL(blob);
};

export const stripParagraphTags = (html: string): string => {
  if (!html) return "";
  return html.replace(/<p><br><\/p>/gi, "").trim();
};

/** Match embed iframe sandbox so nested carousel iframes can run scripts in preview. */
export const EMAIL_PREVIEW_IFRAME_SANDBOX =
  "allow-same-origin allow-scripts allow-popups";
